<template>
  <v-expansion-panel v-if="selectedModule">
    <v-expansion-panel-header class="py-5">
      {{ selectedModule.title || selectedModule.name || 'Unknown' }}
    </v-expansion-panel-header>
    <v-expansion-panel-content eager>
      <text-input
        :value="module.key"
        class="mb-2"
        label="Key"
        hint="Dynamically generated via Title"
        persistent-hint
        disabled
        required
      />

      <div v-if="module.template_options.length" class="mb-6">
        <select-list
          v-for="(templateOption, index) in module.template_options"
          :key="index"
          v-model="templateOption.value"
          :items="getTemplateOptionOptions(templateOption.template_option)"
          :disabled="readonly"
          :label="capitalize(templateOption.template_option.replace(/_/gi, ' '))"
          class="mb-2"
          hide-details
          @change="onInput(module.template_options, 'template_options')"
        />
      </div>

      <div class="d-flex align-center justify-space-between">
        <select-list
          v-model="newTemplateOption"
          :items="templateOptionSelect"
          :disabled="readonly"
          class="mr-4"
          label="Template Option Select"
          clearable
          hide-details
        />

        <v-btn :disabled="!newTemplateOption" color="primary" depressed class="mr-4" @click="onTemplateOptionAdd">
          <v-icon left>add</v-icon>
          <span>Add Template Option</span>
        </v-btn>

        <v-btn color="error" depressed :disabled="isLoading || readonly" @click="onDeleteClick">
          <v-icon left>delete</v-icon>
          <span>Remove</span>
        </v-btn>
      </div>
    </v-expansion-panel-content>
    <v-divider />
  </v-expansion-panel>
</template>

<script>
import { capitalize } from 'lodash-es'
import TextInput from '@/components/forms/text-input'
import SelectList from '@/components/forms/select-list'

const blankTemplateOption = ({ template_option, options = [], default_option = null }) => ({
  value: default_option ? default_option : options.length ? options[1] : null,
  operator: '=',
  template_option,
})

export default {
  name: 'ModuleBlock',
  components: { TextInput, SelectList },
  props: {
    module: {
      type: Object,
      required: true,
    },
    modules: {
      type: Array,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    newTemplateOption: null,
  }),
  computed: {
    selectedModule() {
      return this.modules.find(({ id }) => this.module.id === id)
    },
    templateOptionSelect() {
      return this.templateOptions.map(({ template_option }) => ({
        key: capitalize(template_option.replace(/_/gi, ' ')),
        value: template_option,
        disabled: this.module.template_options.some(
          ({ template_option: templateOption }) => templateOption === template_option
        ),
      }))
    },
  },
  methods: {
    capitalize,
    getTemplateOptionOptions(templateOption) {
      const { options = [] } = this.templateOptions.find(({ template_option }) => template_option === templateOption)
      return options.map(option => ({ key: capitalize(option), value: option }))
    },
    onTemplateOptionAdd() {
      const templateOption = this.templateOptions.find(
        ({ template_option }) => template_option === this.newTemplateOption
      )
      const templateOptions = [...this.module.template_options, blankTemplateOption(templateOption)]
      this.onInput(templateOptions, 'template_options')
      this.newTemplateOption = null
    },
    onDeleteClick() {
      this.$emit('delete')
    },
    onInput(value, model) {
      this.$emit('input', { ...this.module, [model]: value })
    },
  },
}
</script>
